import type { FaireProductEntity } from "../../entity_types/product";

export const p_yquv9gpjrp: FaireProductEntity = {
  token: "p_yquv9gpjrp",
  type: "product",
  name: "Adjustable Evil Eye Ring, Zircon Evil Eye Ring, Rose Gold Silver Ring",
  brandToken: "b_ur24ckegrz",
  brandName: "Evileyefavor",
  imageUrl: "https://cdn.faire.com/fastly/c660ddeec6a3ba2d8eb6c4978fd616e77adc7b44bbbf0a27cb19d946edd7a0e8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/daaaead2422e7b4bbb1a84fa70f99009ea9922b785af1efcf6e3dff752310bb1.jpeg",
    "https://cdn.faire.com/fastly/501a574b30e771ef25f1bf0c9df4c1358e6356a122db412a87eee2fbe0712547.jpeg",
    "https://cdn.faire.com/fastly/25b1bb8662547cf63a4da46a1f22791ff73dbeae1614501950c07a41ae110c07.jpeg",
    "https://cdn.faire.com/fastly/207fd780aed4fe4cdb8561950d7c8d2268e9e279f5b5f4867650960a1fbf22cc.jpeg",
    "https://cdn.faire.com/fastly/99cc6dbc62c7def83ee86096f4be7120c1f0e44fc3d9cbd17cfde6f7e7adf802.jpeg"
  ],
  priceDollars: 11.02,
  description: "Evil eye ring, zircon evil eye charm ring, rose gold silver ring, adjustable ring, greek evil eye jewelry, joint rings, minimalist ring\n\n🌟 These evil eye ring available as 3 colors: \n- Rose Gold\n- Gold\n- Silver\n\n🌟 These evil eye rings are ADJUSTABLE. These are suitable for every sizes. \n\n🌟 These evil eye rings can be used as JOINT RINGS as well.",
  tags: [],
  msrpDollars: 18.36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:10.067Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
